import React, { useState } from "react";
import { DialogActions, Button, CircularProgress } from "@material-ui/core";
import IntegrationsService from "../../../../../../../../services/IntegrationsService";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../../../../redux/actions/ui";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import AddNewItem from "../../../../../../../components/modals/AddNewItem";
import { useForm } from 'react-hook-form';
import {
  Grid
} from "@material-ui/core";
import { Controller } from 'react-hook-form';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';


const useStyles = makeStyles(theme => ({
  // DialogTitle
  DialogActions: {
    justifyContent: "center",    
    "& .MuiButton-root": {
      // backgroundColor: 'red'
      minWidth: "12em",
      padding: "0.5em"
    }
  },  
  table: {
    minWidth: 650,
    maxHeight: 100,
  }
}));


function RunSyncIntegration(props) {
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const classes = useStyles();
  const dispatch = useDispatch();

  const { register, errors, handleSubmit, setError,  getValues, control } = useForm({
    validateCriteriaMode: "all",
    mode: "onChange"
  });
  
  const onSubmit = async data => {
    const {start_date, end_date} = data;    
    if(start_date > end_date){
      setError("start_date", "notMatch", "Start Date can't be greater than End Date");
    }else if(end_date.diff(start_date, 'days') > 30){
      setError("end_date", "notMatch", "End Date can't be greater than 30 days");
    }else{
      setIsLoadingSubmit(true);
      try{
        await IntegrationsService.syncGetIntegrationForSS(props.integrationId, start_date, end_date);
        setIsLoadingSubmit(false);
        dispatch(showSnackBar("Starting sync!"));
        props.onClose();
      }catch (error) {
        setIsLoadingSubmit(false);
      }
    }
  };
   
  const actions = (
    <DialogActions className={classes.DialogActions}>
      <Button onClick={() => props.onClose(false)} color="primary" variant="outlined" >
          Cancel
        </Button>
        <Button 
          type="submit"
          disabled={isLoadingSubmit}    
          onClick={handleSubmit(onSubmit)}
          color="primary" 
          autoFocus 
          variant="contained"
          startIcon={
            (isLoadingSubmit) ? <CircularProgress size={24}/> : <SaveIcon />
          }>
          Get Data
        </Button>
    </DialogActions>
  )

  return (
    <AddNewItem open={props.open} onClose={props.onClose} isLoading={isLoadingSubmit} actions={actions} title="Sync data">

      <form noValidate autoComplete="off" >         
        <Grid container spacing={3} direction="row">
          <Grid item xs={6}>
              <Controller 
                as={KeyboardDatePicker}
                disabled={isLoadingSubmit}
                autoOk
                format="MM/DD/YYYY"
                views={["year", "month", "date"]}
                label="Start Date"
                placeholder="mm/dd/yyyy"
                variant="inline"    
                inputVariant="filled"
                fullWidth={true} 
                error={errors.start_date ? true : false}
                helperText={errors.start_date ? errors.start_date.message : null}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                // rules={{ required: "Field Required", pattern: /^[A-Za-z]+$/i  }}
                inputRef={register({ 
                  required: true,
                  validate: value => value >  getValues().endDate || "start_date can't be greater than endDate" 
                })}
                name="start_date" 
                defaultValue={moment()}
                control={control} />
          </Grid> 

            <Grid item xs={6}>
            <Controller 
              as={KeyboardDatePicker}
              autoOk
              disabled={isLoadingSubmit}
              format="MM/DD/YYYY"
              views={["year", "month", "date"]}
              label="End Date"
              placeholder="mm/dd/yyyy"
              variant="inline"    
              inputVariant="filled"
              fullWidth={true} 
              error={errors.end_date ? true : false}
              helperText={errors.end_date ? errors.end_date.message : null}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              inputRef={register({ 
                required: true
              })}
              name="end_date"               
              control={control} 
              defaultValue={moment()} />           
          </Grid> 

        </Grid>
      </form>
      
      
    </AddNewItem>
  )
}

export default RunSyncIntegration;